import { render, staticRenderFns } from "./HeaderDaTabela.vue?vue&type=template&id=0e1702c9&scoped=true"
import script from "./HeaderDaTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDaTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDaTabela.vue?vue&type=style&index=0&id=0e1702c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1702c9",
  null
  
)

export default component.exports